export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 prose prose-invert" data-testid="privacy-page">
      <div className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-3">Confidentialité</div>
      <h1 className="font-display text-4xl md:text-5xl text-ink-900">Politique de confidentialité</h1>
      <p className="text-muted2 mt-3">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>

      <div className="mt-10 space-y-8 text-ink-700 text-sm leading-relaxed">
        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">1. Données collectées</h2>
          <p>Chez E.C.S, nous collectons uniquement les données strictement nécessaires au bon fonctionnement du service :</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-muted2">
            <li>Email et nom complet (identification)</li>
            <li>Progression pédagogique (leçons validées, résultats de quiz)</li>
            <li>Métadonnées de paiement (identifiant transaction, montant, statut — <strong className="text-ink-900">aucune donnée bancaire n'est stockée</strong>)</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">2. Durée de conservation</h2>
          <p>Compte actif : conservation indéfinie tant que vous utilisez le service. Compte supprimé : purge complète sous 72h. Certificats délivrés : conservés indéfiniment pour permettre leur vérification publique (loi française sur les certifications privées).</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">3. Vos droits (RGPD)</h2>
          <p>Vous disposez à tout moment de vos droits d'accès, rectification, effacement et portabilité. Rendez-vous dans <em className="text-gold-700">Compte → Mes données personnelles</em> pour les exercer en un clic.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">4. Partage et hébergement</h2>
          <p>Nous ne revendons ni ne partageons vos données avec des tiers, sauf obligations légales. Nos serveurs sont hébergés en <strong className="text-ink-900">Union Européenne</strong>. Le chiffrement au repos utilise AES-256.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">5. Cookies</h2>
          <p>Trois catégories : nécessaires (obligatoires), analytics (opt-in), marketing (opt-in). Vous pouvez modifier vos préférences à tout moment via le bandeau cookies.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-gold-700 mb-2">6. Contact DPO</h2>
          <p>Pour toute question : <a className="text-gold-700 hover:text-gold-700-700-600" href="mailto:dpo@ecs.local">dpo@ecs.local</a></p>
        </section>
      </div>
    </div>
  );
}
